import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ArchiveIcon from "@material-ui/icons/Archive";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

import axios from "axios";
import {handleConcursosDetailError} from "../../utils/errors";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    dialog: {
        "& .MuiDialog-paper": {
            maxWidth: "700px",
        },
    },
    tooltip: {
        fontSize: "14px",
        fontWeight: "normal",
    },
}));

export default function DraftDeleteModal(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [openSpinner, setOpenSpinner] = React.useState(false);
    let comment = ""

    const handleOpen = (event) => {
        setOpen(!open);
    };

    const handleChange = (event) =>{
        comment = event.target.value
    };

    const handleError = (error) => {
        setOpen(false);
        setOpenSpinner(false);
        handleConcursosDetailError(error)
    }

    const handleClick = () => {
        setOpenSpinner(true);
        axios
            .delete(window.ENV.API_URL + "/concursos/" + props.concursoId + "/",{data:{comentario:comment}})
            .then((res) => {
                handleOpen();
                setOpenSpinner(false);
                window.location.reload();
            })
            .catch((error) => handleError(error));
    };

    return (
        <Fragment>
            {/*
      <Button
        startIcon={<ArchiveIcon />}
        color="secondary"
        onClick={handleOpen}
      >
        {props.label}
      </Button>*/}

            <Tooltip
                onClick={handleOpen}
                title={<span className={classes.tooltip}>{props.label}</span>}
            >
                <IconButton>
                    <ArchiveIcon/>
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleOpen}
                scroll={"paper"}
                className={classes.dialog}
                fullWidth
            >
                <DialogTitle>Archivar concurso</DialogTitle>
                <DialogContent dividers={true}>
                    <p className="text-center">
                        Escriba el motivo para archivar el concurso{" "}
                        <strong>{props.name}</strong>
                    </p>
                    <div>
                        <TextField
                            label="Motivo"
                            multiline
                            fullWidth
                            rowsMax={6}
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        disableElevation
                        style={{marginRight: "1em"}}
                        variant="contained"
                        onClick={handleOpen}
                    >
                        Cancelar
                    </Button>
                    <Button
                        disableElevation
                        color="secondary"
                        variant="contained"
                        onClick={handleClick}
                    >
                        Archivar
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}
